var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OidcAccessToken, OidcSessionStorage } from '@ori/auth';
class TokenProvider {
    constructor() {
        this.oidcSessionStorage = new OidcSessionStorage();
    }
    getAuthorizationToken() {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield this.getTokenServiceUserToken();
            if (!token) {
                token = yield this.getSessionStorageToken();
            }
            if (!token) {
                token = yield this.getTokenServicePublicToken();
            }
            if (!token) {
                throw new Error('Missing access token');
            }
            return token;
        });
    }
    getCustomerId() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const token = yield this.getToken();
                return token.getClaim('customer_id');
            }
            catch (_a) {
                return null;
            }
        });
    }
    getToken() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = window.ori) === null || _a === void 0 ? void 0 : _a.tokenService) {
                const oriToken = yield window.ori.tokenService.getToken();
                if (oriToken) {
                    return new OidcAccessToken(oriToken.Token);
                }
            }
            const token = this.oidcSessionStorage.getAccessToken();
            if (token !== null) {
                return token;
            }
            throw Error('Missing auth token');
        });
    }
    getTokenServiceUserToken() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = window.ori) === null || _a === void 0 ? void 0 : _a.tokenService) {
                try {
                    const oriToken = yield window.ori.tokenService.getToken();
                    if (oriToken) {
                        return oriToken.Token;
                    }
                }
                catch (_b) {
                    // silence is golden
                }
            }
            return null;
        });
    }
    getSessionStorageToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = this.oidcSessionStorage.getAccessToken();
            if (token !== null) {
                return token.toString();
            }
            return null;
        });
    }
    getTokenServicePublicToken() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = window.ori) === null || _a === void 0 ? void 0 : _a.tokenService) {
                try {
                    const oriToken = yield window.ori.tokenService.getPublicToken();
                    if (oriToken) {
                        return oriToken.Token;
                    }
                }
                catch (_b) {
                    // silence is golden
                }
            }
            return null;
        });
    }
}
const tokenProvider = new TokenProvider();
export { tokenProvider as TokenProvider };
